import { LitElement, html } from './-global.min.js'

class HHBlogFilters extends LitElement {
  static properties = {}

  constructor() {
    super()

    this.section = this.dataset.section
  }

  connectedCallback() {
    super.connectedCallback()

    setTimeout(() => {
      this.handleInitialScroll()
    }, 10)

    if (document.querySelector('main').querySelector('section').getAttribute('id').includes(this.section)) {
      document.querySelector('.js-header-bg').classList.add('tbbt')
      this.closest('.main-blog').classList.add('main-blog__padding')
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback()
  }

  handleInitialScroll() {
    const isScrollable = this.scrollWidth > this.clientWidth
    if (!isScrollable) return

    const activeTFilter = this.querySelector('.active-filter')
    this.scrollLeft = activeTFilter?.offsetLeft - 20
  }

  render() {
    return html`<slot></slot> `
  }
}

customElements.define('hh-blog-filters', HHBlogFilters)
